import { createApp, h, provide } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from '@/router'
import { ApolloClients } from '@vue/apollo-composable'
import { apolloClient, routerApolloClient } from '@/shared/graphql/client'
import VueVirtualScroller from 'vue-virtual-scroller'
import TruncateDirective from '@dacr/vue-truncate'
import { TooltipDirective } from '@dacr/ui/next'
import { createHead } from '@unhead/vue'
import { analytics } from '@/shared/services/analytics'
import { useFeatureFlagStore } from '@/shared/stores/featureFlags'
import en from '@/shared/i18n/en.json'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import '@/assets/css/font.css'
import '@/assets/css/tailwind.css'
import '@/assets/css/transition.css'

const app = createApp({
  setup() {
    provide(ApolloClients, {
      default: apolloClient,
      router: routerApolloClient,
    })
  },
  render: () => h(App),
})

// Deferred analytics init
if (typeof requestIdleCallback !== 'undefined') {
  requestIdleCallback(() => analytics.init())
} else {
  setTimeout(() => analytics.init(), 1)
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  messages: { en },
})

app.use(createPinia())

const featureFlagStore = useFeatureFlagStore()
featureFlagStore.init()

app.use(router)
app.use(i18n)
app.use(VueVirtualScroller)
app.use(createHead())

app.directive('truncate', TruncateDirective)
app.directive('tooltip', TooltipDirective)

app.mount('#app')
